import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import eventlistView from '../views/eventlist.vue'
import businesslistView from '../views/businesslist.vue'
import propertylistView from '../views/propertylist.vue'
import singleeventlistView from '../views/singleeventlist.vue'
import singlebusinesslistView from '../views/singlebusinesslist.vue'
import productdetail from '../views/productdetail.vue'
import listing from '../views/listing.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import form from '../views/form.vue'
import profile from '../views/profile.vue'
import categorylist from '../views/categorylist.vue'
import emergencylist from '../views/emergencylist.vue'
import dailyneed from '../views/dailyneed.vue'
import searchbar from '../views/searchbar.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/productdetail',
    name: 'productdetail',
    component: productdetail
  },

  {
    path: '/list',
    name: 'eventlist',
    component: eventlistView
  },

  {
    path: '/businesslist',
    name: 'businesslist',
    component: businesslistView
  },

  {
    path: '/propertylist',
    name: 'propertylist',
    component: propertylistView
  },

  {
    path: '/singleeventlist',
    name: 'singleeventlist',
    component: singleeventlistView
  },
  {
    path: '/singlebusinesslist',
    name: 'singlebusinesslist',
    component: singlebusinesslistView
  },
  {
    path: '/listing',
    name: 'listing',
    component: listing
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },

  {
    path: '/register',
    name: 'register',
    component: register
  },

  {
    path: '/form',
    name: 'form',
    component: form
  },

  {
    path: '/profile',
    name: 'profile',
    component: profile
  },
  {
    path: '/categorylist',
    name: 'categorylist',
    component: categorylist
  },

  {
    path: '/emergencylist',
    name: 'emergencylist',
    component: emergencylist
  },
  {
    path: '/dailyneed',
    name: 'dailyneed',
    component: dailyneed
  },
  {
    path: '/searchbar',
    name: 'searchbar',
    component: searchbar
  },







  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]
// Update the document title dynamically

const router = createRouter({
    
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(savedPosition);
          }, 100); // wait for DOM/content load
        });
      }
      return { top: 0 };
      }
})

export default router
